import {
  getUsersPending,
  getUsersSuccess,
  getUsersError,
  getUserPending,
  getUserSuccess,
  getUserError,
  updateUserPending,
  updateUserSuccess,
  updateUserError,
  searchUsersPending,
  searchUsersSuccess,
  searchUsersError,
  createUserPending,
  createUserSuccess,
  createUserError,
  removeUserPending,
  removeUserSuccess,
  removeUserError,
  getUserByTokenPending,
  getUserByTokenSuccess,
  getUserByTokenError,
} from "../actions/user";
import {
  deleteAlertError,
  deleteAlertPending,
  deleteAlertSuccess,
  createAlertError,
  createAlertPending,
  createAlertSuccess,
  updateAlertError,
  updateAlertPending,
  updateAlertSuccess,
} from "../actions/userAlert";

import {
  changePasswordError,
  changePasswordPending,
  changePasswordSuccess,
} from "../actions/changePassword";

import { UserService } from "../../lib/qc-api-client";

export function getUsers(userId) {
  return dispatch => {
    dispatch(getUsersPending());
    UserService.getUsersByUser(userId).then(response => {
      dispatch(getUsersSuccess({
        users:       response.data.users,
        totalUsers:  response.data.total,
      }));
      return response.data.users;
    }).catch(error => {
      console.error(error)
      dispatch(getUsersError(error));
    })
  }
}

export function searchUsers(keywords, location, options) {
  return dispatch => {
    dispatch(searchUsersPending());
    UserService.searchUsers(keywords, location, options).then(response => {
      dispatch(searchUsersSuccess({
        users:       response.data.users,
        filters:    response.data.filters,
        totalUsers:  response.data.total,
        usersLoaded: true
      }));
      return response.data.users;
    }).catch(error => {
      console.error(error)
      dispatch(searchUsersError(error));
    })
  }
}

export function updateUser(user) {
  return (dispatch) => {
    dispatch(updateUserPending());
    UserService.updateUser(user)
      .then((response) => {
        dispatch(
          updateUserSuccess({
            user: response.data.user,
            message: response.data?.message,
          })
        );
        return response.data.user;
      })
      .catch((error) => {
        dispatch(updateUserError(error));
      });
  };
}

export function createUser(user, resume) {
  return dispatch => {
    dispatch(createUserPending());
    UserService.create(user, user, resume).then(response => {
      dispatch(createUserSuccess({
        user: response.data.user
      }));
      return response.data.user;
    }).catch(error => {
      console.error(error)
      dispatch(createUserError(error));
    })
  }
}

export function getUserByToken(token) {
  return dispatch => {
    dispatch(getUserByTokenPending());
    UserService.identify(token).then(response => {
      dispatch(getUserByTokenSuccess({
        user: response.data.user
      }));
      return response.data.user;
    }).catch(error => {
      console.error(error)
      dispatch(getUserByTokenError(error));
    })
  }
}

export function getUser(id) {
  return dispatch => {
    dispatch(getUserPending());
    UserService.getUser(id).then(response => {
      dispatch(getUserSuccess({
        user: response.data.user
      }));
      return response.data.user;
    }).catch(error => {
      console.error(error)
      dispatch(getUserError(error));
    })
  }
}

export function employerSignUp(user) {
  return (dispatch) => {
    dispatch(createUserPending());
    UserService.employerSignUp(user)
      .then((response) => {
        dispatch(
          createUserSuccess({
            user: response.data,
          })
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(createUserError(error));
      });
  };
}

export function applicatSignUp(user) {
  return (dispatch) => {
    dispatch(createUserPending());
    UserService.applicantSignUp(user)
      .then((response) => {
        localStorage.setItem(
          "qcUserToken",
          JSON.stringify(response.data.auth_token)
        );
        localStorage.setItem("qcUser", JSON.stringify(response.data.user));
        dispatch(
          createUserSuccess({
            user: response.data,
          })
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(createUserError(error));
      });
  };
}

export function removeUser(user) {
  return (dispatch) => {
    dispatch(removeUserPending());
    UserService.removeUser(this.props.user, user)
      .then((response) => {
        dispatch(
          removeUserSuccess({
            user: response.data.user,
          })
        );
        return response.data.user;
      })
      .catch((error) => {
        dispatch(removeUserError(error));
      });
  };
}

export const deleteAlert = (alert) => {
  return (dispatch) => {
    dispatch(deleteAlertPending());
    UserService.removeUserAlert(alert)
      .then((response) => {
        dispatch(deleteAlertSuccess({ alert: response.data }));
      })
      .catch((error) => dispatch(deleteAlertError(error)));
  };
};

export const createAlert = (user, alert) => {
  return (dispatch) => {
    dispatch(createAlertPending());
    UserService.createUserAlert(user, alert)
      .then((response) => {
        dispatch(createAlertSuccess({ alert: response.data }));
      })
      .catch((error) => dispatch(createAlertError(error)));
  };
};

export const updateAlert = (user, alert) => {
  return (dispatch) => {
    dispatch(updateAlertPending());
    UserService.updateUserAlert(user, alert)
      .then((response) => {
        dispatch(updateAlertSuccess({ alert: response.data }));
      })
      .catch((error) => dispatch(updateAlertError(error)));
  };
};

export const changePassword = (data) => {
  return (dispatch) => {
    dispatch(changePasswordPending());
    UserService.changePassword(data)
      .then((response) => {
        dispatch(
          changePasswordSuccess({
            user: response.data.user,
          })
        );
      })
      .catch((error) => {
        dispatch(changePasswordError(error));
      });
  };
};
